import * as _ from 'lodash';
import { Vector3 } from 'three';
import { Dimensions } from './../../core/types';

export class Outside {
  public dimensions: Dimensions;
  public position: Vector3;
  constructor(
    dimensions: Dimensions,
    position: Vector3,
  ) {
    this.dimensions = { width: 0, length: 0, height: 0 };
    this.position = new Vector3();
    this.times100(dimensions, position);
  }

  public times100(dimensions: Dimensions, position: Vector3) {
    this.dimensions.length = _.round(dimensions.length * 100, 2);
    this.dimensions.width = _.round(dimensions.width * 100, 2);
    this.dimensions.height = _.round(dimensions.height * 100, 2);
    this.position.x = _.round(position.x * 100, 2);
    this.position.y = _.round(position.y * 100, 2);
    this.position.z = _.round(position.z * 100, 2);
  }
}
